import * as React from "react";

interface FeatureCardProps {
  title: string;
  description: string;
  icon: string;
  altText: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  title,
  description,
  icon,
  altText,
}) => {
  return (
    <article
      className="p-0 rounded-2xl overflow-hidden transition-all bg-white bg-opacity-10 duration-[0.3s] text-right"
      dir="rtl"
    >
      <img
        className="w-full h-auto aspect-[2/1] object-cover"
        src={icon}
        alt={altText}
        loading="lazy"
      />
      <div className="p-6">
        <h3 className="mb-4 text-2xl font-semibold">{title}</h3>
        <p className="leading-relaxed text-neutral-400">{description}</p>
      </div>
    </article>
  );
};

export default FeatureCard;
